import api from '@/services/api';
import type {
    Product,
    ProductListParams,
    PaginationMeta,
} from '../types/products.types';
import { transformApiProduct, type RawApiProduct } from './productTransform';
import { parseRejectionReasons } from './parseRejectionReasons';

interface RawProductsPage {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from: number;
    to: number;
    data: RawApiProduct[];
    meta?: { rejection_reasons?: unknown }; // present (per #46) only when data is empty
}

export interface ProductsPage {
    data: Product[];
    meta: PaginationMeta;
}

const smrPath = '/smr';

export const fetchProducts = async (params: ProductListParams = {}): Promise<ProductsPage> => {
    const response = await api.get<RawProductsPage>(`${smrPath}/products`, { params });
    return {
        data: response.data.data.map(transformApiProduct),
        meta: {
            current_page: response.data.current_page,
            last_page: response.data.last_page,
            per_page: response.data.per_page,
            total: response.data.total,
            from: response.data.from,
            to: response.data.to,
            rejection_reasons: parseRejectionReasons(response.data.meta),
        },
    };
};
